import Vue from 'vue'
import Router from 'vue-router'

import { constantRouterMap } from './routes'

Vue.use(Router)

const router = new Router({
  routes: constantRouterMap,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js